const focusableElementsSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
export const focusBackwards = (event, firstFocusableElement, lastFocusableElement) => {
    if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        event.preventDefault();
    }
};
export const focusForward = (event, firstFocusableElement, lastFocusableElement) => {
    if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        event.preventDefault();
    }
};
export const handleExternalFocus = (event, modal, firstFocusableElement) => {
    if (modal.current && !modal.current.contains(event.target)) {
        firstFocusableElement.focus();
        event.preventDefault();
    }
};
export const interceptFocus = (event, modal) => {
    const { firstFocusableElement, focusableContent, lastFocusableElement } = getFocusableContent(modal);
    if (focusableContent.length === 0) {
        return;
    }
    // if shift key pressed for shift + tab combination
    if (event.shiftKey) {
        focusBackwards(event, firstFocusableElement, lastFocusableElement);
        return;
    }
    // if last focusable element is focused then focus first focusable element after pressing tab
    focusForward(event, firstFocusableElement, lastFocusableElement);
    // If afterwards external element is focused, refocus it to the first focusable element in modal
    handleExternalFocus(event, modal, firstFocusableElement);
};
const getFocusableContent = (modal) => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    const focusableContent = (((_a = modal.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll(focusableElementsSelector)) || []);
    const firstFocusableElement = focusableContent[0];
    const lastFocusableElement = focusableContent[focusableContent.length - 1];
    return {
        focusableContent,
        firstFocusableElement,
        lastFocusableElement,
    };
};
//# sourceMappingURL=ModalOverlay.utils.js.map